<section class="text-gray-600 body-font">
  <div class="container px-5 py-8 pb-8 mx-auto flex flex-wrap">

    <div class="flex flex-wrap w-full mb-8">
      <div class="lg:w-1/3 w-full mb-6 lg:mb-0">
        <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-500">Brands we do</h1>
        <div class="h-1 w-20 bg-[#ff4d06] rounded"></div>
      </div>
      <p class="lg:w-2/3 w-full leading-relaxed text-gray-500">We carry a wide selection of top-tier computer
        brands to suit your needs, from everyday computing to cutting-edge gaming. Whether you're looking for a reliable
        HP or Dell for work, a sleek and powerful ASUS laptop for school, or a high-performance MSI rig to conquer the
        latest games, we have the perfect brand for you.</p>
    </div>

    <div class="flex md:flex-row flex-col gap-4 ">


      <div class="flex flex-wrap md:-m-2 -m-1 w-full md:w-1/2  ">
        <div class="flex flex-wrap w-1/2">
          <div class="md:p-2 p-1 w-1/2 brand_img_c">
            <img alt="gallery" class="w-full object-contain h-full object-center block aspect-video	 brand_img" loading="lazy"
              ngSrc="assets/brandnames/Acer-logo.webp" width="125" height="70">
          </div>
          <!-- 70.25w x 37.7656h -->
          <div class="md:p-2 p-1 w-1/2  brand_img_c">
            <img alt="gallery" class="w-full object-contain h-full object-center block  aspect-video	 brand_img"loading="lazy"
              ngSrc="assets/brandnames/asus.webp"  width="125" height="70">
          </div>
          <div class="md:p-2 p-1 w-full  brand_img_c">
            <img alt="gallery" class="w-full h-full object-contain object-center block aspect-video	 brand_img" loading="lazy"
              ngSrc="assets/brandnames/MSI-Logo.webp"   width="500" height="281">
          </div>
        </div>
        <div class="flex flex-wrap w-1/2">
          <div class="md:p-2 p-1 w-full  brand_img_c">
            <img alt="gallery" class="w-full h-full object-contain object-center block aspect-video	 brand_img" loading="lazy"
              src="assets/brandnames/Samsung_logo.webp">
          </div>
          <div class="md:p-2 p-1 w-1/2  brand_img_c">
            <img alt="gallery" class="w-full object-contain h-full object-center block aspect-video	 brand_img" loading="lazy"
              src="assets/brandnames/HP_Inc.-Logo.wine.svg">
          </div>
          <div class="md:p-2 p-1 w-1/2  brand_img_c">
            <img alt="gallery" class="w-full object-contain h-full object-center block aspect-video	 brand_img" loading="lazy"
              src="assets/brandnames/Logitech_logo.svg.webp">
          </div>
        </div>
      </div>


      <div class="flex flex-wrap md:-m-2 -m-1 w-full md:w-1/2">
        <div class="flex flex-wrap w-1/2">
          <div class="md:p-2 p-1 w-1/2  brand_img_c">
            <img alt="gallery" class="w-full object-contain h-full object-center block aspect-video	 brand_img" loading="lazy"
              ngSrc="assets/brandnames/wd.webp"  width="125" height="70">
          </div>
          <div class="md:p-2 p-1 w-1/2  brand_img_c">
            <img alt="gallery" class="w-full object-contain h-full object-center block aspect-video	 brand_img" loading="lazy"
              src="assets/brandnames/havit.webp">
          </div>
          <div class="md:p-2 p-1 w-full  brand_img_c">
            <img alt="gallery" class="w-full h-full object-contain object-center block aspect-video	 brand_img" loading="lazy"
              ngSrc="assets/brandnames/seagate.webp"  width="500" height="281">
          </div>
        </div>
        <div class="flex flex-wrap w-1/2  brand_img_c">
          <div class="md:p-2 p-1 w-full">
            <img alt="gallery" class="w-full h-full object-contain object-center block aspect-video	 brand_img" loading="lazy"
              src="assets/brandnames/Transcend-Logo.webp">
          </div>
          <div class="md:p-2 p-1 w-1/2  brand_img_c">
            <img alt="gallery" class="w-full object-contain h-full object-center block aspect-video	 brand_img" loading="lazy"
              ngSrc="assets/brandnames/Kingston-Emblem.webp"  width="125" height="70">
          </div>
          <div class="md:p-2 p-1 w-1/2  brand_img_c">
            <img alt="gallery" class="w-full object-contain h-full object-center block aspect-video	 brand_img" loading="lazy"
              src="assets/brandnames/SanDisk-Logo.wine.webp"     >
          </div>
        </div>
      </div>

    </div>


  </div>
</section>